import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { chatMessageSent } from '../../store/offer_chats';
import { setPhoneCollapse } from '../../store/phone_collapse';
import { toggle as toggleCallbackPopup } from '../../store/popups/callback';
import { getParent } from '../../utils/offer_helpers';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import { getBookingTracking } from '../../utils/tracking_booking';
import { IOfferContactsAsideDispatchProps, IOfferContactsAsideStateProps, OfferContactsAside } from './index';
import { getDynamicCalltrackingSiteBlockId } from '../../selectors/getDynamicCalltrackingSiteBlockId';
import { getNewbuildingId } from '../../selectors';

function mapStateToProps(state: IState): IOfferContactsAsideStateProps {
  const { abGroup, offerData, offerChat, isPikBookingSucceeded, bookedOfferId } = state;
  const { agent, agentAvailability, offer, user, kp } = offerData;

  return {
    abGroup,
    agent,
    agentAvailability,
    isPhonesVisible: state.printModal.isPhonesVisible,
    kp,
    offer,
    offerChat,
    parent: getParent(offerData),
    user,

    bookedOfferId,
    bookingTracking: getBookingTracking(offer, agent),
    isCommercial: isCommercial(getOfferType(offer)),
    isPikBookingSucceeded,
    newbuildingId: getNewbuildingId(state),
    siteBlockId: getDynamicCalltrackingSiteBlockId(state),
    isAuthenticated: !!(state.offerData.user && state.offerData.user.isAuthenticated),
    dynamicCalltrackingPlaceType: 'ContactsAside',
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IOfferContactsAsideDispatchProps {
  return {
    chatMessageSent: () => dispatch(chatMessageSent()),
    openCallbackPopup: () => dispatch(toggleCallbackPopup('floating', true)),
    setPhoneCollapse: () => dispatch(setPhoneCollapse()),
  };
}

export const OfferContactsAsideContainer = connect<IOfferContactsAsideStateProps, IOfferContactsAsideDispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferContactsAside);
